import React, { FC } from 'react';
import { IconButton } from '@mui/material';

import { Checkbox, InfoFilledIcon, Tooltip } from 'src/shared/components';
import { useTranslate } from 'src/shared/providers';

interface Props {
  isPartialDay: boolean;
  onCheck: () => void;
}

export const PartialAbsenceCheckbox: FC<Props> = ({ isPartialDay, onCheck }) => {
  const { t } = useTranslate();

  return (
    <div className="mb-3">
      <Checkbox className="me-2" checked={isPartialDay} onCheck={onCheck} label={t('absences.partialDayQuestion')} />
      <Tooltip title={t('absences.thisFeatureAllowsYouToRequestAFewHoursOff')}>
        <IconButton className="p-0" size="small" color="info">
          <InfoFilledIcon />
        </IconButton>
      </Tooltip>
    </div>
  );
};
